import { Component, Host, h, Prop, State } from '@stencil/core';
import '../loader-component/loader-component'
import '../header-component/header-component';


/**
#### Sample screen shot
![image info](https://infonet.nyp.org/webc/PublishingImages/nyptwitter-component.PNG)
*/


@Component({
  tag: 'nyptwitter-component',
  styleUrl: 'nyptwitter-component.css',
  scoped: true
})
export class NyptwitterComponent {

   /**
   *Required - Unique ID.
   */
   @Prop() componentid: string = "comp-id";

      /**
   *Required - if header attribute is true
   */
   @Prop() sectiontitle: string = "Section Title";
 
   /**
   *Required - if header attribute is true
   */
   @Prop() titleiconurl: string = "";
 
   /**
   *Optional - default header
   */
   @Prop() header: boolean = true;
 
   /**
  *Optional - vertical scroll bar
  */
   @Prop() verticalscroll: boolean = false;
 
   /**
  *Optional - vertical scroll bar height
  */
   @Prop() verticalscrollheight: number = 200;
    /**
*Optional - header background color
*/
@Prop() headerbgcolor: string ="white"

/**
*Optional -header text color
*/
@Prop() headertextcolor: string = "black"
/**
*Optional -header border bottom css
*/
@Prop() headerborderbottom: string = "1px solid #CE2127"
 
     /**
   *Optional -twitter username. for example nyphospital
   */
   @Prop() twitterhandle: string =""

     /**
*Optional - is it SP Online site
*/
@Prop() online:boolean=false;

 /**
  *Required - site url if its sp online site
  */
  @Prop() siteurl: string = "";

   @State() isLoading: boolean = true
   
   

  componentDidLoad(){

    const url = '//platform.twitter.com/widgets.js';

    // only load script once
    if (!Array.from(document.querySelectorAll('script')).some(elm => elm.id == 'twitter-js')) {
      let script = document.createElement('script');
      script.src = url;
      script.id = 'twitter-js';
      document.getElementsByTagName('head')[0].appendChild(script);
    }
    this.isLoading=false
 
  }


  render() {

    
    let style = {}
    let styleWithHeader = {}
    let parentstyle = {}
    if (this.verticalscroll) {
      style = {
        maxHeight: this.verticalscrollheight + "px",
        overflowY: "auto",
      }
      styleWithHeader = {
        maxHeight: this.verticalscrollheight + "px",
        overflowY: "auto",
      }

      parentstyle = {
        minHeight: (this.verticalscrollheight + 20) + "px",
        backgroundColor: "white",
        borderBottomRightRadius: "5px",
        borderBottomLeftRadius: "5px",
        paddingBottom: "10px"
      }
    }
    else {
      style = {
      }
      parentstyle = {
        backgroundColor: "white",
        borderBottomRightRadius: "5px",
        borderBottomLeftRadius: "5px",
        paddingBottom: "10px"
      }
    }

    return (
      this.isLoading ? <loader-component /> :
      this.header ?
        <div>
          <header-component sectiontitle={this.sectiontitle} titleiconurl={this.titleiconurl}  headerbgcolor={this.headerbgcolor} headertextcolor={this.headertextcolor} headerborderbottom={this.headerborderbottom} />

          <div class="row gx-0" style={parentstyle} >
            <div style={styleWithHeader}>
            <div class="col-md-12">
            <a href={'//twitter.com/' + this.twitterhandle} class="twitter-timeline"></a>;
            </div>
            </div>
          </div>
        </div>
        :
        <div class="row gx-0" style={parentstyle} >
          <div style={style}>
            <div class="col-md-12">
          <a href={'//twitter.com/' + this.twitterhandle} class="twitter-timeline"></a>;
          </div>
          </div>
        </div>
    );
  }

}
